import { z } from "zod";
import { ProposalSchema } from "./Proposal";

export const ProposalRequestSchema = ProposalSchema.pick({
    description: true,
    startDate: true,
    endDate: true,
});

export type ProposalRequest = z.infer<typeof ProposalRequestSchema>;
